import { render, staticRenderFns } from "./EnvironmentListPage.vue?vue&type=template&id=2904cdaa&scoped=true&"
import script from "./EnvironmentListPage.vue?vue&type=script&lang=js&"
export * from "./EnvironmentListPage.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentListPage.vue?vue&type=style&index=0&id=2904cdaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904cdaa",
  null
  
)

export default component.exports